// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"_f16f4b1"};